import { render, staticRenderFns } from "./CockpitLabelComponent.vue?vue&type=template&id=9bdecb9e&scoped=true"
import script from "./CockpitLabelComponent.vue?vue&type=script&lang=js"
export * from "./CockpitLabelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdecb9e",
  null
  
)

export default component.exports